import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const codeWrapper = style({
  display: "grid",
  gap: vars.space.m,
});

export const pText = style({
  fontSize: vars.fontSizes.body.l,
});
